/* eslint-disable @next/next/no-html-link-for-pages */
import { FC } from 'react';
import Link from 'next/link';

// sub
import nav from '../nav.module.scss';
import top from '../top-nav/top-nav.module.scss';
import sub from '../sub-nav/sub-nav.module.scss';
import user from '../sub-nav/user-account-bar/user-account-bar.module.scss';

const NavSkeleton: FC = () => {
  return (
    <div className={nav.navContainer} data-testid="navSkeleton">
      <nav className={top.topNavContainer}>
        <div className={top.navHeaderLayout}>
          <ul className={top.navItemsLayout}>
            <li className={top.navItem} id="FrontShopShopNavNode">
              <Link className={top.skeletonText} href="/?nav=home">
                Shop
              </Link>
            </li>
            <li className={top.navItem} id="FrontShopPrescriptionNavNode">
              <Link className={top.skeletonText} href="https://mypharmacy.shoppersdrugmart.ca/en">
                Prescriptions
              </Link>
            </li>
            <li className={top.navItem} id="FrontShopHealthAndPharmacyNavNode">
              <Link className={top.skeletonText} href="https://www1.shoppersdrugmart.ca/en/health-and-pharmacy">
                Health &amp; Pharmacy
              </Link>
            </li>
            <li className={top.navItem} id="FrontShopFoodAndHomeNavNode">
              <Link className={top.skeletonText} href="https://www1.shoppersdrugmart.ca/en/food-and-home">
                Food &amp; Home
              </Link>
            </li>
            <li className={top.navItem} id="FrontShopPromotionsNavNode">
              <Link className={top.skeletonText} href="https://www1.shoppersdrugmart.ca/en/promotions">
                Promotions
              </Link>
            </li>
            <li className={top.navItem} id="FrontShopPCOptimumNavNode">
              <Link className={top.skeletonText} href="https://www1.shoppersdrugmart.ca/en/pcoptimum">
                PC Optimum
              </Link>
            </li>
            <li className={top.navItem} id="FrontShopCommunityNavNode">
              <Link className={top.skeletonText} href="https://www1.shoppersdrugmart.ca/en/community">
                Community
              </Link>
            </li>
            <li className={top.navItem} id="FrontShopMoreByShoppersNavNode">
              <Link className={top.skeletonText} href="https://www1.shoppersdrugmart.ca/en/more-by-shoppers">
                More by Shoppers
              </Link>
            </li>
          </ul>
        </div>
      </nav>
      <nav title="Navigation Menu" className={sub.subNavContainer}>
        <div className={sub.navHeaderLayout}>
          <ul className={sub.navItemsLayout}>
            <li className={sub.navItem} id="FrontShopBeautyNavNode">
              <Link className={sub.skeletonText} href="/beauty">
                Beauty
              </Link>
            </li>
            <li className={sub.navItem} id="FrontShopPersonalCareNavNode">
              <Link className={sub.skeletonText} href="/shop/Categories/PersonalCare/c/FS-PC">
                Personal Care
              </Link>
            </li>
            <li className={sub.navItem} id="FrontShopHealthNavNode">
              <Link className={sub.skeletonText} href="/shop/Categories/Health/c/FS-HP">
                Health
              </Link>
            </li>
            <li className={sub.navItem} id="FrontShopBabyAndChildNavNode">
              <Link className={sub.skeletonText} href="/shop/Categories/BabyAndChild/c/FS-BC">
                Baby &amp; Child
              </Link>
            </li>
            <li className={sub.navItem} id="FrontShopHomeAndElectronicsNavNode">
              <Link className={sub.skeletonText} href="/shop/Categories/HomeAndElectronics/c/FS-HL">
                Home &amp; Electronics
              </Link>
            </li>
            <li className={sub.navItem} id="FrontShopOffersNavNode">
              <Link className={sub.skeletonText} href="/FS-Offers">
                Offers
              </Link>
            </li>
          </ul>
          <div className={user.lvl1UserAccountNav}>
            <ul className={user.userAccountNavContainer}>
              <li>
                <Link className={sub.skeletonText} href="https://accounts.pcid.ca/oauth2/v1/authorize">
                  Sign In
                </Link>
              </li>
              <li>
                <Link className={sub.skeletonText} href="/favourite">
                  {/* WARN: using a NextJS image here is known as a possible cause of a bug in dev (https://gitlab.lblw.ca/sdm/sdm-frontshop/-/merge_requests/73) */}
                  <img src="https://bb-prod-marketing-image.s3.amazonaws.com/heart.svg" alt="shopping bag" />
                  <span>Favourites</span>
                </Link>
              </li>
              <li>
                <Link className={sub.skeletonText} href="/shoppingbag">
                  {/* WARN: using a NextJS image here is known as a possible cause of a bug in dev (https://gitlab.lblw.ca/sdm/sdm-frontshop/-/merge_requests/73) */}
                  <img
                    src="https://assets.beauty.shoppersdrugmart.ca/bb-prod-marketing-image/site-media/shopping-bag--black.svg"
                    alt="shopping bag"
                    width={30}
                    height={30}
                  />
                  <span className={user.shoppingBag} aria-label="Cart">
                    Bag (<span id="js-cart-item-count-nav-sub">0</span>)
                  </span>
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </div>
  );
};

export default NavSkeleton;
